import { configureStore } from "@reduxjs/toolkit";
import UserStatusSlice from "./userStatus";
import ActivePageSlice from "./activePage";
const store = configureStore({
  reducer: {
    userStatus: UserStatusSlice,
    activePage: ActivePageSlice,
  },
});

export default store;
